<template>

	<div class="product-add">
		<!--form表单-->
		<el-form size="small" ref="form" :model="form" label-width="150px">
			<!--添加门店-->
			<div class="common-form">周期 | 时段设置</div>
			<el-form-item label="服务半径">
				<el-input placeholder="请输入半径" type="number" style="width: 360px;" v-model="form.scope">
					<template slot="append">KM</template>
				</el-input>
			</el-form-item>
			<el-form-item label="工作日">
				<el-checkbox-group v-model="form.week">
					<el-checkbox label="1" name="type">周一</el-checkbox>
					<el-checkbox label="2" name="type">周二</el-checkbox>
					<el-checkbox label="3" name="type">周三</el-checkbox>
					<el-checkbox label="4" name="type">周四</el-checkbox>
					<el-checkbox label="5" name="type">周五</el-checkbox>
					<el-checkbox label="6" name="type">周六</el-checkbox>
					<el-checkbox label="7" name="type">周日</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item label="时段">
				<el-time-picker is-range v-model="value1" range-separator="至" format="HH:mm" value-format="HH:mm"
					start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
				</el-time-picker>
			</el-form-item>
			<!--提交-->
			<div class="common-button-wrapper">
				<el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
			</div>
		</el-form>
	</div>

</template>

<script>
	import SettingApi from "@/api/setting.js";

	export default {
		data() {
			return {
				/*form表单数据*/
				form: {
					scope: '', // 服务半径
					week: [],
					start_time: '', // 开始工作时间
					end_time: '' // 结束工作时间
				},
				loading: false,
				value1: []
			};
		},
		created() {
			this.getData();
		},
		methods: {
			// 获取
			getData() {
				let self = this;
				SettingApi.waiterGET({}, true)
					.then(data => {
						self.form.scope = data.data.vars.values.scope
						self.form.week = data.data.vars.values.week.split(',')
						self.form.start_time = data.data.vars.values.start_time
						self.form.end_time = data.data.vars.values.end_time
						self.value1 = [self.form.start_time,self.form.end_time]
					})
					.catch(error => {});
			},

			//提交表单
			onSubmit() {
				let self = this;
				self.loading = true;
				var param = {
					scope: self.form.scope, // 服务半径
					week: self.form.week.join(','),
					start_time: self.value1 ? self.value1[0] : '', // 开始工作时间
					end_time: self.value1 ? self.value1[1] : '' // 结束工作时间
				}
				SettingApi.waiterPOST(param, true)
					.then(data => {
						self.loading = false;
						self.getData();
						self.$message({
							message: "恭喜你，设置成功",
							type: "success"
						});
					})
					.catch(error => {
						self.loading = false;
					});
			}
		}
	};
</script>

<style>
	.tips {
		color: #ccc;
	}
</style>


// WEBPACK FOOTER //
// src/views/technician/deploy/index.vue